export const States = {
  AWAITS_CONFIRMATION: 'Aguarda Confirmação',
  IN_PREPARATION: 'Em Preparação',
  multiSelect: 'Estados Seleccionados ({items})'
}



// WEBPACK FOOTER //
// ./src/translations/pt/states.js